export default __webpack_public_path__ + "static/media/MATH-COURSE.4224be18.jpg";